import {lazy, Suspense} from 'react';
import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';
import '../styles/Prescription.scss';

const ChartBPChart = lazy(() => import('../moretemplates/BP CHART/ChartBPChart'));
const ChartBpSugarChart = lazy(() => import('../moretemplates/BP SUGAR CHART/ChartBpSugarChart'));
const ChartCostingSheet = lazy(() => import('../moretemplates/COSTING SHEET/ChartCostingSheet'));
const ChartDonorStimulationCheckList = lazy(() => import('../moretemplates/DonorStimulationCheckList/ChartDonorStimulationCheckList'));
const ChartFertilityInvestigation = lazy(() => import('../moretemplates/FERTILITY INVESTIGATION/ChartFertilityInvestigation'));
const ChartIvfFailureInvestigations = lazy(() => import('../moretemplates/IVF FAILURE INVESTIGATIONS/ChartIvfFailureInvestigations'));
const ChartKickCountChart = lazy(() => import('../moretemplates/KICK COUNT CHART/ChartKickCountChart'));
const ChartPretermLabour = lazy(() => import('../moretemplates/PRETERM LABOUR WORKUP/ChartPretermLabour'));
const ChartRplInvestigationBasic = lazy(() => import('../moretemplates/RPL INVESTIGATION BASIC/ChartRplInvestigationBasic'));
const ChartRplInvestigationExtensive = lazy(() => import('../moretemplates/RPL INVESTIGATION EXTENSIVE/ChartRplInvestigationExtensive'));
const RplWorkUp = lazy(() => import('../moretemplates/RPL WorkUp/RplWorkUp'));

function Charts(props) {
  const {type} = useParams();
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const chartType = type;

  const PrintDiv = () => {
    var new_str = document.getElementById('demo').innerHTML;
    var originalContents = document.body.innerHTML;
    var printContent = `
      <style>
        @page {
          margin: 0;
        }
        body {
          margin: 0;
          padding: 0;
        }
        .demo {
          width: 100%;
          max-width: 1200px;
          margin: 20px auto 0;
        }
        table {
          border-collapse: collapse;
          border: 1px solid black;
          width: 100%;
          margin-bottom: 10px;
          table-layout: fixed;
        }
        table th, table td {
          border: 1px solid black;
          padding: 10px;
          text-align: center;
          height: 60px;
          min-width: 80px;
        }
        /* Costing Sheet specific styles */
        #CostingSheet table th,
        #CostingSheet table td {
          text-align: left;
          height: auto;
          min-width: auto;
        }
        #CostingSheet table {
          table-layout: auto;
        }
      </style>
      ${new_str}
    `;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContents;
    return false;
  };

  var mediaQueryList = window.matchMedia('print');
  mediaQueryList.addListener(function (mql) {
    if (mql.matches) {
      console.log('before print dialog open');
    } else {
      window.location.reload();
      console.log('after print dialog closed');
    }
  });

  return (
    <>
      <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
        <div className='patient-header'>
          <div className='row'>
            <div className='col'>
              <h3 className='page-title'>{chartType}</h3>
              <ul className='breadcrumb'>
                <li className='breadcrumb-item'>
                  <a href='/' style={{textDecoration: 'none', color: 'black'}}>
                    Dashboard /
                  </a>
                  <a href='/Patients' style={{textDecoration: 'none', color: 'black'}}>
                    &nbsp;Patient
                  </a>
                </li>
                <li className='breadcrumb-item active'>Charts</li>
              </ul>
            </div>
            <div className='col-auto'>
              <button onClick={() => PrintDiv()} style={{padding: '10px 20px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer'}}>
                Print Chart
              </button>
            </div>
          </div>
        </div>
        <Suspense fallback={<div className='text-center mt-3'>Loading chart...</div>}>
          <div>
            {chartType === 'Bp Sugar Chart' && (
              <ChartBpSugarChart loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Blood Pressure Chart' && (
              <ChartBPChart loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Kick Count Chart' && (
              <ChartKickCountChart loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Preterm Labour' && (
              <ChartPretermLabour loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Costing Sheet' && (
              <ChartCostingSheet loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'RPL Workup' && <RplWorkUp loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />}
            {chartType === 'RPL Investigation Basic' && (
              <ChartRplInvestigationBasic loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'RPL Investigation Extensive' && (
              <ChartRplInvestigationExtensive loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'IVF Failure Investigations' && (
              <ChartIvfFailureInvestigations loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}

            {chartType === 'DONOR STIMULATION CHECK LIST' && (
              <ChartDonorStimulationCheckList loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
            {chartType === 'Fertility investigation' && (
              <ChartFertilityInvestigation loaderchange={props.loaderchange} popupalert={props.popupalert} popuptext={props.popuptext} PrintDiv={PrintDiv} chartType={chartType} />
            )}
          </div>
        </Suspense>
      </div>
    </>
  );
}

export default Charts;
